import Http from '@/http';
import { IHomeTodoResponse } from '@/api/typings/home';

export function apiHomeTodoList() {
  return Http.get<void, IHomeTodoResponse>('/hr/home/todo', undefined);
}
